































import { defineComponent, PropType } from '@nuxtjs/composition-api'
import isEmpty from 'lodash/fp/isEmpty'
import JsonRteField from '~/components/global/cms/JsonRteField.vue'
import { RteNode } from '~/types/rte/rteTypes'
// import { DEVKEY } from '@/common/constants/cms'
// import ContentTargeter from '~/components/global/targeters/ContentTargeter.vue'

export default defineComponent({
  components: {
    JsonRteField,
  },
  props: {
    trademarks: {
      type: Array,
      default: () => [],
    },
    legals: {
      type: Array,
      default: () => [],
    },
    legalStatementRteNode: {
      type: Object as PropType<RteNode | undefined>,
      default: undefined,
    },
  },
  setup() {
    return { isEmpty }
  },
})
